import { STORE_VARIABLE } from '../enums/sessiontorage';
import { statusErrors, stringErrors } from './errors';

export function GetFriendlyStatusError(error: number): string {
  if (statusErrors[error]) {
    return statusErrors[error];
  }
  return stringErrors.UNKNOWN_ERROR;
}

export function GetFriendlyError(error: string): string {
  if (stringErrors[error]) {
    return stringErrors[error];
  }
  return stringErrors.UNKNOWN_ERROR;
}

export const rankColors = ['warning.300', 'warning.900', 'error.300', 'error.900'];

export function isNew(createdAt?: Date, daysThreshold = 3): boolean {
  if (!createdAt) {
    return false;
  }
  const millisDiff = new Date().getTime() - createdAt.getTime();
  return millisDiff / 1000 / 60 / 60 / 24 < daysThreshold;
}

export function millisDiff(date1: Date, date2 = new Date()): number {
  return date2.getTime() - date1.getTime();
}

export const clientPathQueryParamBuilder = (value: string, property = STORE_VARIABLE.SITE_NAME, notFirst = false) =>
  `${notFirst ? '&' : '?'}${property}=${value}`;

export const getGraphPageFooterAssetsPath = (config: any) => {
  const url = process.env.REACT_APP_API_URL as string;
  const logoPath = config?.footerLogo?.graphPage?.logo || '';
  return logoPath.length ? `${url}${logoPath}` : undefined;
};

// Turns kWh into MWh/GWh if it's needed
export const kilowattsFormatter = (value: number) => {
  if (value >= 10000000) {
    return { value: value / 1000000, unit: 'GWh' };
  }
  if (value >= 10000) {
    return { value: value / 1000, unit: 'MWh' };
  }
  return { value: value, unit: 'kWh' };
};

// export function formatNumber(number: number): string {
//   return new Intl.NumberFormat('de-DE').format(number);
// }

export function formatNumber(num: number, decimals = 2): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(num);
}

// Some sites have SMA revenue-grade meters wired with reversed polarity, so the provider
// reports production/usage under the opposite field (gridFeedIn <-> gridConsumption). List the
// affected device ids in `config.smaApi.reverseMeterIds` and this swaps those fields on that
// device's measurement responses so the downstream widget formulas produce correct, positive
// values. Per-device (not whole-site) because some sites only have one reversed meter.
export const normalizeSmaResponse = (data: any, config: any): any => {
  const reverseMeterIds: Array<number | string> = config?.smaApi?.reverseMeterIds ?? [];
  if (!reverseMeterIds.length || !data || !Array.isArray(data.set)) {
    return data;
  }
  const deviceId = data?.device?.deviceId;
  const isReversed = reverseMeterIds.some((id) => String(id) === String(deviceId));
  if (!isReversed) {
    return data;
  }
  return {
    ...data,
    set: data.set.map((item: any) =>
      item && (item.gridFeedIn !== undefined || item.gridConsumption !== undefined)
        ? { ...item, gridFeedIn: item.gridConsumption ?? 0, gridConsumption: item.gridFeedIn ?? 0 }
        : item
    )
  };
};

export const sumAll = (arr: any[], fieldName: string): number => {
  if (!arr || arr.length === 0) return 0;
  return arr.reduce((acc, item) => acc + (item[fieldName] ?? 0), 0);
};

export const getAverage = (arr: any[], fieldName: string): number => {
  if (arr.length === 0) return 0; // Handle empty array case
  const sum = arr.reduce((acc, item) => acc + (item[fieldName] ?? 0), 0);
  return sum / arr.length;
};
